export default __webpack_public_path__ + "static/media/cover_20231009_01.2a2430dc.jpg";